import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const ModalForbiddenMedicine = ({ feasibility, listForbiddenMedicines, doCloseModalForbiddenMedicine, opened }) => {
    const [medicamento, setMedicamento] = React.useState(null);
    const [estado, setEstado] = React.useState(1);

    const [openModal, setOpenModal] = React.useState(opened);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {

    }, []);

    const addForbiddenMedicineimiento = async () => {
        //Validacion
        if (medicamento == null) {
            alertModal(false, "Medicamento");
            return;
        }
        let dataForbiddenMedicine = 
        {
            id_estudio:parseInt(feasibility.id_estudio),
            id_tercero:parseInt(feasibility.id_tercero),
            medicamento:medicamento,
            estado:parseInt(estado),
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}mediproh/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataForbiddenMedicine)
        }).then(response => {
            response.json();
        }).then(data => {
            listForbiddenMedicines();
            closeModal();
        }).catch(err => {

        });
    }

    const closeModal = () => {
        doCloseModalForbiddenMedicine();
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Agregar Medicamento Prohibido</h5>
                        </div>

                        <Row>
                            <Col md={6}>
                                <TextField
                                    label=" "
                                    helperText="Medicamento Prohibido"
                                    value={medicamento}
                                    onChange={(event) => {
                                        setMedicamento(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    select
                                    label=" "
                                    helperText="Estado"
                                    value={estado}

                                    onChange={(event) => {
                                        setEstado(event.target.value);
                                    }}

                                    style={{ minWidth: '300px', maxWidth: '100%' }}

                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Activo
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        Inactivo
                                    </MenuItem>
                                </TextField>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addForbiddenMedicineimiento();
                            }}
                        >
                            Crear
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalForbiddenMedicine;
